export const BASE = {
  name: 'funnels',
  path: '/sites/:siteId/funnels',
};
